export default class ViewModelUtils {
  static isBlockViewModel(model: any): model is Editor.Visualizer.BlockViewModel {
    return model?.typeName === 'BlockViewModel';
  }

  static isPageViewModel(model: any): model is Editor.Visualizer.PageViewModel {
    return model?.typeName === 'PageViewModel';
  }
}
